import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  _Length___get_kilometers__impl__syiikt2ggk89idxg8kf as _Length___get_kilometers__impl__syiikt,
  Companion_instance2ik3kqchmtmbs as Companion_instance,
} from './usefulTypes.mjs';
import { coerceIn1xblvmyr0tby6 as coerceIn } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { StringCompanionObject_instance2dx16b5pp3v3z as StringCompanionObject_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import {
  serializer1x79l67jvwntn as serializer,
  DoubleArraySerializertger6kqq08hw as DoubleArraySerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  buildClassSerialDescriptors2a6xdp6mrtw as buildClassSerialDescriptor,
  SerialDescriptorbzxbhtn690r4 as SerialDescriptor,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  Exceptiondt2hlxn7j7vw as Exception,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return GeoCoordinateGeoJsonSerializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  return Companion_instance_0;
}
var GeoCoordinateClass;
function GeoCoordinate() {
  if (GeoCoordinateClass === VOID) {
    class $ {
      constructor(latitude, longitude) {
        this.latitude_1 = latitude;
        this.longitude_1 = longitude;
      }
      distanceToKilometers_gyt5cm_k$(other) {
        return _Length___get_kilometers__impl__syiikt(this.distanceTo_gulrsv_k$(other));
      }
      distanceTo_gulrsv_k$(other) {
        var theta = this.longitude_1 - other.longitude_1;
        // Inline function 'kotlin.math.sin' call
        var x = deg2rad(this.latitude_1);
        var tmp = Math.sin(x);
        // Inline function 'kotlin.math.sin' call
        var x_0 = deg2rad(other.latitude_1);
        var tmp_0 = tmp * Math.sin(x_0);
        // Inline function 'kotlin.math.cos' call
        var x_1 = deg2rad(this.latitude_1);
        var tmp_1 = Math.cos(x_1);
        // Inline function 'kotlin.math.cos' call
        var x_2 = deg2rad(other.latitude_1);
        var tmp_2 = tmp_1 * Math.cos(x_2);
        // Inline function 'kotlin.math.cos' call
        var x_3 = deg2rad(theta);
        var dist = tmp_0 + tmp_2 * Math.cos(x_3);
        // Inline function 'kotlin.math.acos' call
        var x_4 = coerceIn(dist, -1.0, 1.0);
        dist = Math.acos(x_4);
        dist = rad2deg(dist);
        dist = dist * (60 * 1.1515);
        return Companion_instance.get_miles_tb1bul_k$(dist);
      }
      copy_6r5gqz_k$(latitude, longitude) {
        return new (GeoCoordinate())(latitude, longitude);
      }
      copy$default_am4guy_k$(latitude, longitude, $super) {
        latitude = latitude === VOID ? this.latitude_1 : latitude;
        longitude = longitude === VOID ? this.longitude_1 : longitude;
        return $super === VOID ? this.copy_6r5gqz_k$(latitude, longitude) : $super.copy_6r5gqz_k$.call(this, latitude, longitude);
      }
      toString() {
        return 'GeoCoordinate(latitude=' + this.latitude_1 + ', longitude=' + this.longitude_1 + ')';
      }
      hashCode() {
        var result = getNumberHashCode(this.latitude_1);
        result = imul(result, 31) + getNumberHashCode(this.longitude_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GeoCoordinate()))
          return false;
        if (!equals(this.latitude_1, other.latitude_1))
          return false;
        if (!equals(this.longitude_1, other.longitude_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'GeoCoordinate', VOID, VOID, VOID, VOID, VOID, {0: GeoCoordinateGeoJsonSerializer_getInstance});
    GeoCoordinateClass = $;
  }
  return GeoCoordinateClass;
}
function GeoCoordinateGeoJsonSerializer$descriptor$lambda($this$buildClassSerialDescriptor) {
  $this$buildClassSerialDescriptor.element$default_ey7ac9_k$('type', serializer(StringCompanionObject_instance).get_descriptor_wjt6a0_k$());
  $this$buildClassSerialDescriptor.element$default_ey7ac9_k$('coordinates', GeoCoordinateGeoJsonSerializer_getInstance().das_1.get_descriptor_wjt6a0_k$());
  return Unit_instance;
}
var GeoCoordinateGeoJsonSerializerClass;
function GeoCoordinateGeoJsonSerializer() {
  if (GeoCoordinateGeoJsonSerializerClass === VOID) {
    class $ {
      constructor() {
        GeoCoordinateGeoJsonSerializer_instance = this;
        this.das_1 = DoubleArraySerializer();
        var tmp = this;
        tmp.descriptor_1 = buildClassSerialDescriptor('com.lightningkite.services.data.GeoCoordinate/geojson', [], GeoCoordinateGeoJsonSerializer$descriptor$lambda);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      deserialize_sy6x50_k$(decoder) {
        // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
        var descriptor = this.descriptor_1;
        var composite = decoder.beginStructure_yljocp_k$(descriptor);
        var lat = 0.0;
        var lon = 0.0;
        $l$loop: while (true) {
          var index = composite.decodeElementIndex_bstkhp_k$(GeoCoordinateGeoJsonSerializer_getInstance().descriptor_1);
          switch (index) {
            case 0:
              composite.decodeStringElement_3oenpg_k$(GeoCoordinateGeoJsonSerializer_getInstance().descriptor_1, 0);
              break;
            case 1:
              // Inline function 'kotlin.let' call

              var it = composite.decodeSerializableElement$default_j0zaoi_k$(GeoCoordinateGeoJsonSerializer_getInstance().descriptor_1, 1, GeoCoordinateGeoJsonSerializer_getInstance().das_1);
              if (it.length < 2)
                throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$('A coordinate needs a longitude and a latitude; got ' + it.length + ' number(s).');
              lat = it[1];
              lon = it[0];
              break;
            case -1:
              break $l$loop;
            default:
              // Inline function 'kotlin.error' call

              var message = 'Unexpected index: ' + index;
              throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
          }
        }
        var result = new (GeoCoordinate())(lat, lon);
        composite.endStructure_1xqz0n_k$(descriptor);
        return result;
      }
      serialize_befgks_k$(encoder, value) {
        // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
        var descriptor = this.descriptor_1;
        var composite = encoder.beginStructure_yljocp_k$(descriptor);
        composite.encodeStringElement_1n5wu2_k$(GeoCoordinateGeoJsonSerializer_getInstance().descriptor_1, 0, 'Point');
        var tmp = GeoCoordinateGeoJsonSerializer_getInstance().descriptor_1;
        var tmp_0 = GeoCoordinateGeoJsonSerializer_getInstance().das_1;
        // Inline function 'kotlin.doubleArrayOf' call
        var tmp$ret$2 = new Float64Array([value.longitude_1, value.latitude_1]);
        composite.encodeSerializableElement_isqxcl_k$(tmp, 1, tmp_0, tmp$ret$2);
        composite.endStructure_1xqz0n_k$(descriptor);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_befgks_k$(encoder, value instanceof GeoCoordinate() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'GeoCoordinateGeoJsonSerializer', VOID, VOID, [KSerializer()]);
    GeoCoordinateGeoJsonSerializerClass = $;
  }
  return GeoCoordinateGeoJsonSerializerClass;
}
var GeoCoordinateGeoJsonSerializer_instance;
function GeoCoordinateGeoJsonSerializer_getInstance() {
  if (GeoCoordinateGeoJsonSerializer_instance === VOID)
    new (GeoCoordinateGeoJsonSerializer())();
  return GeoCoordinateGeoJsonSerializer_instance;
}
var GeoCoordinateArraySerializerClass;
function GeoCoordinateArraySerializer() {
  if (GeoCoordinateArraySerializerClass === VOID) {
    class $ {
      constructor() {
        GeoCoordinateArraySerializer_instance = this;
        this.delegate_1 = DoubleArraySerializer();
        this.descriptor_1 = SerialDescriptor('com.lightningkite.services.data.GeoCoordinate/longLatArray', this.delegate_1.get_descriptor_wjt6a0_k$());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      deserialize_sy6x50_k$(decoder) {
        // Inline function 'com.lightningkite.services.data.deserializing' call
        var tmp;
        try {
          // Inline function 'kotlin.let' call
          var it = decoder.decodeSerializableValue_xpnpad_k$(GeoCoordinateArraySerializer_getInstance().delegate_1);
          var tmp0_longitude = it[0];
          var tmp1_latitude = it[1];
          tmp = new (GeoCoordinate())(tmp1_latitude, tmp0_longitude);
        } catch ($p) {
          var tmp_0;
          if ($p instanceof SerializationException()) {
            var e = $p;
            throw e;
          } else {
            if ($p instanceof Exception()) {
              var e_0 = $p;
              throw SerializationException().new_kotlinx_serialization_SerializationException_pjmzgo_k$('Not a valid ' + this.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() + ': ' + e_0.message, e_0);
            } else {
              throw $p;
            }
          }
        }
        return tmp;
      }
      serialize_befgks_k$(encoder, value) {
        // Inline function 'kotlin.doubleArrayOf' call
        var tmp$ret$0 = new Float64Array([value.longitude_1, value.latitude_1]);
        encoder.encodeSerializableValue_3uuzip_k$(this.delegate_1, tmp$ret$0);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_befgks_k$(encoder, value instanceof GeoCoordinate() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'GeoCoordinateArraySerializer', VOID, VOID, [KSerializer()]);
    GeoCoordinateArraySerializerClass = $;
  }
  return GeoCoordinateArraySerializerClass;
}
var GeoCoordinateArraySerializer_instance;
function GeoCoordinateArraySerializer_getInstance() {
  if (GeoCoordinateArraySerializer_instance === VOID)
    new (GeoCoordinateArraySerializer())();
  return GeoCoordinateArraySerializer_instance;
}
function deg2rad(deg) {
  return deg * 3.141592653589793 / 180.0;
}
function rad2deg(rad) {
  return rad * 180.0 / 3.141592653589793;
}
//region block: init
Companion_instance_0 = new (Companion())();
//endregion
//region block: exports
export {
  GeoCoordinate as GeoCoordinate2xsokvzumk7qu,
  Companion_instance_0 as Companion_instance3paxl0a3a7ty8,
  GeoCoordinateArraySerializer_getInstance as GeoCoordinateArraySerializer_getInstance3ijv0mfbjm6uh,
  GeoCoordinateGeoJsonSerializer_getInstance as GeoCoordinateGeoJsonSerializer_getInstancew33zho1zb4lc,
};
//endregion

//# sourceMappingURL=GeoCoordinate.mjs.map
